<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/14wKQu4/media/FC-9781788780629.jpg?1692135101474" alt="This image is the cover for the book The Repeat"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">The Repeat
      </h1>
      <p class="bookDescription body article font2">
        <p>Home, safe and sound after a quick turnaround trip to Russia as a chaperone, Greg Redman is pleased to be back in the UK even though his employer is a friend.<br/>A quiet night in turns into a nightmare when an old TV program is shown again.<br/>A rouge chat show-host also sees the show.<br/>A journalist at the top of his game, caught in a trap of mistaken loyalty, and two lost souls make a dreadful mistake.<br/>Is murder on someone's mind?<br/>Will the law enforcement help?<br/>Kinman and Wells discover a link to a previous case and will be calling in ex-military pals. Will they be able to put an end to some dangerous and shocking events?</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Josie Wells
      </h2>
      
      <p class="authorDescription body article">Josie lives in Sherborne Dorset in the UK; she is interested in politics and current affairs, and how the world is working. Having specialised in dementia care and although retired, still keeps an interest in health and social care, mental health, crime and punishment. Josie paints oil on canvas and has already begun her third book; a passion for fast cars and beautiful engineering is always on the agenda.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?535dc7ba